import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSpark } from "@/lib/store";
import { nextAction } from "@/lib/journey";
import { ModeTag } from "@/components/ActivityMode";

// The one visually dominant action. Everything else on the page is secondary to this.
export const NextAction = ({ compact = false }) => {
  const { profile } = useSpark();
  const action = nextAction(profile);
  if (!action) return null;
  return (
    <section
      data-testid="next-action"
      data-kind={action.kind}
      className={`relative rounded-[2rem] ${compact ? "p-7 sm:p-8" : "p-8 sm:p-12"}`}
      style={{ background: "hsl(var(--spark-warmth))", border: "1px solid rgba(44,80,160,0.28)" }}
    >
      <div className="grid md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <p className="spark-eyebrow-copper spark-eyebrow-with-dot">{action.eyebrow}</p>
          <p data-testid="next-action-headline" className={`mt-3 spark-voice text-[#17171C] leading-snug ${compact ? "text-2xl sm:text-3xl" : "text-3xl sm:text-4xl"}`}>
            {action.headline}
          </p>
          {action.sub && (
            <p data-testid="next-action-sub" className="mt-4 text-[#56565D] leading-relaxed max-w-xl">{action.sub}</p>
          )}
          {action.activity && (
            <div className="mt-4 flex items-center gap-3 text-xs text-[#8A8A91]">
              <ModeTag mode={action.activity.mode} />
              <span>About {action.activity.minutes} minutes</span>
            </div>
          )}
        </div>
        <div className="md:col-span-4 md:justify-self-end">
          <Link data-testid="next-action-cta" to={action.to} className="spark-btn-primary text-base px-7 py-4">
            {action.cta} <ArrowRight size={18} className="ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NextAction;
